import React from "react";
import {Pipeline} from "@morningtrain/react-helpers";
import TriggerPipelineOnNavigate from "./TriggerPipelineOnNavigate";

export default function OnNavigatePipeline({children}) {
    return (
        <Pipeline>
            <TriggerPipelineOnNavigate />
            {children}
        </Pipeline>
    );
}
